module.exports = __webpack_public_path__ + "static/media/hayon2.4deebba4.jpg";